import React, { useState, useEffect } from 'react';
import Modal from '../Modal/Modal';
import { useMetadata } from '../../context/MetadataContext';
import { useUser } from '../../context/UserContext';
import styles from './NicknameModal.module.css';
import { useNicknames } from '../../hooks/useNicknames';

const NicknameModal = ({ isOpen, onClose }) => {
  const { getText, metadata } = useMetadata();
  const { userData } = useUser();
  const [selectedNickname, setSelectedNickname] = useState('');
  // loads the nickname list when the modal opens
  const {
    availableNicknames,
    isLoading,
    isChanging,
    getMoreNicknames,
    changeNickname,
  } = useNicknames(isOpen);

  // Reset the selection when modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedNickname('');
    }
  }, [isOpen]); 

  const handleGetMoreNicknames = () => getMoreNicknames();

  const handleChangeNickname = () => changeNickname(selectedNickname, onClose);

  const handleNicknameSelect = (nickname) => {
    setSelectedNickname(nickname);
  };

  // Don't render if user data is not loaded yet
  if (!userData) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={getText('nicknames.title')}
      className={styles.nicknameModal}
    >
      <div className={styles.content}>
        <div className={styles.currentNickname}>
          <span className={styles.label}>
            {getText('nicknames.current')} 
          </span>
          <span className={styles.currentName}>{userData.nickname}</span>
        </div>

        <div className={styles.instructions}>
          <p>{getText('nicknames.subtitle')}</p>
          <ol>
            <li>{getText('nicknames.step_1')}</li>
            <li>{getText('nicknames.step_2')}</li>
          </ol>
        </div>

        <div className={styles.nicknamesSection}>
          <h3 className={styles.sectionTitle}>
            {getText('nicknames.list_heading')}
          </h3>
          
          <div className={styles.nicknamesList}>
            {isLoading ? (
              <div className={styles.loading}>
                {getText('common_text.loading')}
              </div>
            ) : availableNicknames.length === 0 ? (
              <div className={styles.noNicknames}>
                {metadata?.nickname_modal?.no_nicknames || '-- none --'}
              </div>
            ) : (
              availableNicknames.map((nickname) => (
                <div
                  key={nickname}
                  className={`${styles.nicknameOption} ${
                    selectedNickname === nickname ? styles.selected : ''
                  }`}
                  onClick={() => handleNicknameSelect(nickname)}
                >
                  {nickname}
                </div>
              ))
            )}
          </div>
        </div>

        
        <div className={styles.actions}>
          <button
            className={styles.getNicknamesBtn}
            onClick={handleGetMoreNicknames}
            disabled={isLoading}
          >
            {isLoading 
              ? (getText('common_text.loading')) 
              : (getText('nicknames.get_button'))
            }
          </button>
          
          <button
            className={styles.changeBtn}
            onClick={handleChangeNickname}
            disabled={!selectedNickname || isChanging}
          >
            {isChanging 
              ? (getText('common_text.loading')) 
              : (getText('nicknames.change_button'))
            }
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NicknameModal;